import React from "react";
import {
  GetAllCustomerInfoDetailResponse,
  SaleInfo,
} from "../../../models/customer.model";
import CollapseComponent from "../../../components/collapse/collapseComponent";
import { Grid } from "@mui/material";
import CustomerSaleCard from "./CustomerSaleCard";

interface Props {
  saleInfo: SaleInfo[];
  handleDetail: Function;
  customerInfo: GetAllCustomerInfoDetailResponse;
}
const CustomerHeader = ({ handleDetail, saleInfo, customerInfo }: Props) => {
  return (
    <div>
      <CollapseComponent title="فروش">
        <Grid container gap={"15px"} flexDirection={"column"}>
          {saleInfo?.map((sale, index) => (
            <Grid
              item
              sx={{
                borderBottom:
                  index < saleInfo?.length - 1 ? "1px solid #C1C7CB" : "",
                paddingBottom: index < saleInfo?.length - 1 ? "10px" : "",
              }}
            >
              <CustomerSaleCard
                sale={sale}
                key={index}
                handleDetail={handleDetail}
                customerInfo={customerInfo}
              />
            </Grid>
          ))}
        </Grid>
      </CollapseComponent>
    </div>
  );
};

export default CustomerHeader;
